import React, { useEffect, useState } from "react"
import toast from "react-hot-toast"
import "../styles/global.css"
import "../styles/ConfirmationScreen.css"
import { useModal } from "../context/modalContext"
import { useApp } from "../context/appContext"
import Modal from "./shared/Modal"
import { patchCancelAppointment } from "../services/patchCancelAppointment"
import { patchConfirmAppointment } from "../services/patchConfirmAppointment"
import AddToCalendar from "./AddToCalendar"
import { formatCustomerName, formatDateLong, formatLocation, formatPhoneNumber, formatTestType } from "../utils/lib"
import { useSearchParams } from 'react-router-dom'; // To read query params
import { fbApiUrl } from "./shared/facebooktrack_config";  


const ConfirmationScreen = () => {

  const [bookingConfirmed, setBookingConfirmed] = useState(true)
  const [searchParams, setSearchParams] = useSearchParams(); // Hook to get query params
  const { openModal, isModalOpen, closeModal, modalType, setLoading } = useModal()
  const { form, setForm, setCurrentPage, currentPage } = useApp()
  console.log("Current Page", currentPage);

  const confirmModalAction = async () => {
    setLoading(true)
    if(modalType === 'cancel') {
      const cancelRes = await patchCancelAppointment(form?.appointmentId, form?.bookingForm?.personEmail)
      setLoading(false)
      if(cancelRes?.status === "Cancelled") {
        setBookingConfirmed(false)

        // Wait 2 seconds after API response
        await new Promise(resolve => setTimeout(resolve, 500));

        const url = new URL(window.location.href);
        url.searchParams.delete("appointmentId");
        window.history.replaceState({}, "", url);

        setCurrentPage("map")
        setForm({
          location: null,
          date: null,
          time: null,
          testId: null,
          staffId: "any",
          appointmentId: null,
          clientId: null,
          bookingForm: {
            salutation: "Mr",
            firstName: "",
            lastName: "",
            personMobilePhone: "",
            personEmail: "",
            Diabetes__pc: "No",
            First_Appointment__c: false,
            Dont_Confirm__c: false,
            Communication_Preferences__c: false,
            Marketing_Opt_In__c: false
          }
      })
        toast.success("Appointment cancelled successfully!")
      } else {
        toast.error('Failed to cancel appointment')
      }
    }
    closeModal()
  }

  const changeAppointment = async() => {
      setForm((prevForm) => ({
        ...prevForm, // Retain existing properties
        staffId: "any",
        prev_appointmentId: prevForm.appointmentId, // <-- assigning old appointmentId
        bookingForm: {
          ...prevForm.bookingForm, // Retain existing values in bookingForm
        },
      }));
      setCurrentPage("date-picker")
  }
  
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // Adjust delay if needed
  }, []);


  useEffect(() => {
    // Adjust delay if needed
    console.log('hihihihi mc mc mc');
    console.log(form);
  }, [form]);

  useEffect(() => {
    const confirmBooking = async () => {
      setBookingConfirmed(true); //
    };
  
    confirmBooking();

  }, [form?.appointmentId, form?.clientId, form?.bookingForm?.personEmail, setCurrentPage, setLoading]);


  useEffect(() => {
 
    const sendDataToFacebookAPI_Confirmation = async () => {
      if (!fbApiUrl) {
        console.error("Error: fbApiUrl is not defined!");
      } 
      else {
        try{
      
          const ipResponse = await fetch("https://api64.ipify.org?format=json");
          const ipData = await ipResponse.json();
          const clientIp = ipData.ip; // Extracted IP Address

          // Get User Agent
          const userAgent = navigator.userAgent;


          const data = {
            data: [
              {
                event_name: "Confirm Booking",
                event_time: Math.floor(Date.now() / 1000),
                event_source_url: window.location.href,
                user_data: {
                  client_ip_address: clientIp,
                  client_user_agent: userAgent,
                },
                action_source: "website",
                custom_data: {
                  client_id: form?.clientId,
                  salutation: form?.bookingForm?.salutation,
                  firstName: form?.bookingForm?.firstName,
                  lastName: form?.bookingForm?.lastName,
                  email: form?.bookingForm?.personEmail,
                  phone: form?.bookingForm?.personMobilePhone,
                  other_phone: form?.bookingForm?.personHomePhone,
                  diabetes: form?.bookingForm?.Diabetes__pc,
                  first_appointment: form?.bookingForm?.First_Appointment__c,
                  marketing_opt_in: form?.bookingForm?.Marketing_Opt_In__c,
                  dont_confirm: form?.bookingForm?.Dont_Confirm__c,
                  communication_preferences: form?.bookingForm?.Communication_Preferences__c,
                },
              },
            ],
            test_event_code: "TEST58912",
          };
        
          const response = await fetch(fbApiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          });
      
          const result = await response.json();
        }
        catch (error) {
          console.error("Error sending data to Facebook API:", error);
        }
      }
    }

    sendDataToFacebookAPI_Confirmation();

  }, [form?.clientId, form?.bookingForm?.personEmail]);



  
  useEffect(() => {
    // Redirect if either clientId or location is missing
    if (!form?.clientId || !form?.location) {
      setCurrentPage("map");
      return;
    }

    console.log('mc_mahimahi');
    console.log(form?.appointmentId);

    const url = new URL(window.location.href);
    if (url.searchParams.has("appointmentId")) {
      url.searchParams.set("appointmentId", form?.appointmentId);
      window.history.replaceState({}, "", url.toString());
    }
    

  }, [form?.clientId, form?.location, form?.appointmentId, setCurrentPage]);


  useEffect(() => {
    if (form?.location?.Id && form?.location?.Name) {
      
      if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
      }
      
      let booking_source = "Booking App";
      const locationId = searchParams.get('locationId');
      if(locationId){
        booking_source = form.location.Name;
      }

      window.dataLayer.push({
        event: "store_booking",
        store_id: form.location.Id,
        store_name: form.location.Name,
        event_category: "Bookings",
        event_label: "Store Booking",
        booking_source: booking_source,
        value: 1,
      });
      
      console.log("Updated dataLayer:", window.dataLayer);
    } else {
      console.warn("form location details are missing.");
    }
  }, [form?.location]); 
  
  useEffect(() => {
    console.log("Updated Diabetes__pc:", form?.bookingForm?.Diabetes__pc);
  }, [form?.bookingForm?.Diabetes__pc]);
  

  return (
    <>
      <div className="main">
        {/* Conditionally render based on Diabetes__pc */}  

          {/* {(!form?.reschedule_data || form?.reschedule_data !== '1') && (
            <>
            {form?.bookingForm?.Diabetes__pc === 'Yes' ? (
                <div className="page-text">
                  <h1 className="page-heading">Booking Requested</h1>
                  <p className="page-description">A team member will be in touch soon to confirm your appointment.</p>
                </div>
              ) : form?.bookingForm?.Diabetes__pc === 'No' ? ( */}
                <div className="page-text">
                  <h1 className="page-heading">Booking Confirmed</h1>
                  <p className="page-description">Your appointment has been booked.</p>
                </div>
              {/* ) : null}
            </>
          )} */}


        <div className="content">
          <div className="appointment-time">
            <div className="appointment-time-details">
              <p className="appointment-time-heading">Appointment Time and Date</p>
              <h2 className="appointment-time-slot">{form?.time?.startTimeReadable} - {formatDateLong(form?.time?.appointmentDate)}</h2>
            </div>
          </div>

          <hr className="divider" />

          <div className="appointment-details-confirm">
            <div className="detail-section">
              <h3 className="detail-heading">Store Location</h3>
              <p className="detail-pargraph">{formatLocation(form?.location)}</p>
            </div>

            <div className="detail-section">
              <h3 className="detail-heading">Appointment Type</h3>
              <p className="detail-pargraph">{formatTestType(form?.testId)}</p>
            </div>

            <div className="detail-section">
              <h3 className="detail-heading">Preferred Optometrist</h3>
              <p className="detail-pargraph">{form?.staffName}</p>
            </div>

            {((!form?.reschedule_data || form?.reschedule_data !== '1') && (!form?.prev_appointmentId || form?.prev_appointmentId == ''))&& (
              <>
              <div className="detail-section">
                <h3 className="detail-heading">Appointment for</h3>
                <p className="detail-pargraph">{formatCustomerName(form?.bookingForm)}</p>
                <p className="detail-pargraph">{form?.bookingForm?.personEmail}</p>
                <p className="detail-pargraph">{formatPhoneNumber(form?.bookingForm.personMobilePhone)}</p>
              </div>
              </>
            )}

          </div>

          <hr className="divider" />

          <div className="manage-booking">
            <h3 className="detail-heading">Manage your booking</h3>
            <div className="action-btns confirm-action-btns">
              
              <button className="calendar-btn full-btn make-another-appointment" type="button" onClick={() => { const url = new URL(window.location.href); url.searchParams.delete("appointmentId"); window.history.replaceState({}, "", url); window.location.href = "/booking-app"; }} > Make another Appointment </button>
              {(!form?.reschedule_data || form?.reschedule_data !== '1') && (
                <>
                  <AddToCalendar bookingConfirmed={bookingConfirmed}/>
                </>
              )}
              
              <button className="calendar-btn full-btn change-appointment" type="button" onClick={changeAppointment} disabled={!bookingConfirmed}> Change Appointment </button>


              <button className="calendar-btn full-btn cancel-appointment" type="button" onClick={() => openModal("cancel")} disabled={!bookingConfirmed}>Cancel Appointment</button>

            </div>
          </div>
         
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal} onConfirm={confirmModalAction} type={modalType} />
    </>
  )
}


export default ConfirmationScreen